module.exports = __webpack_public_path__ + "media/images/logo/sf-06ca7f8533a1c6a34d5aa5fdd772034a.gif";